// 【公共組件】版權信息
export default {
   'copyright.desc1': 'Alwayscontrol系統版權所有者：旭衡電子（深圳）有限公司',
   'copyright.desc2': '網站備案信息：粵ICP備2021169764號',
   'copyright.desc3': '聯繫方式：xuheng@alwayscontrol.com.cn',
}
 